import { AnalyticsEvent } from '@mode/shared/util-segment';
import { createAction, props } from '@ngrx/store';

export const showMoreSchemasClicked = createAction(
  `[Schema Browser] 'Show more' schemas clicked`,
  props<{
    context: AnalyticsEvent.Context;
    buttonClicked: string;
    reportToken: string;
  }>()
);

export const showMoreTablesClicked = createAction(
  `[Schema Browser] 'Show more' tables clicked`,
  props<{
    context: AnalyticsEvent.Context;
    buttonClicked: string;
    reportToken: string;
  }>()
);
